import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const JURISDICTIONS_QUERY = gql`
  query Jurisdictions($businessEntityUuid: UUID!) {
    jurisdictions(businessEntityUuid: $businessEntityUuid) {
      jurisdictionCode
    }
  }
`;

export function useJurisdictions(businessEntityUuidOverride) {
  const { businessEntityUuid: contextBusinessEntityUuid } = useBusinessEntity();

  // Use override if provided, otherwise use context businessEntityUuid
  const businessEntityUuid = businessEntityUuidOverride || contextBusinessEntityUuid;

  const { data, error, loading, refetch } = useQuery(JURISDICTIONS_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid,
    },
    // Skip query if no businessEntityUuid is available
    skip: !businessEntityUuid,
  });

  useError(error);

  return {
    data: data?.jurisdictions || [],
    error,
    loading,
    refetch,
  };
}
